import React, { useState } from 'react';
import { SearchIcon, UserIcon, ShoppingBagIcon, MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-91">
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between" data-id="element-92">
        {/* Mobile Menu Button */}
        <button className="md:hidden p-2 text-gray-600" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-93">
          {isMenuOpen ? <XIcon className="w-6 h-6" data-id="element-94" /> : <MenuIcon className="w-6 h-6" data-id="element-95" />}
        </button>

        {/* Logo */}
        <a href="#" className="font-serif text-2xl font-bold text-esbelta-violet tracking-tight" data-id="element-96">
          ESBELTA<sup className="text-sm" data-id="element-97">®</sup>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-98">
          <a href="#" className="text-sm font-medium text-gray-800 hover:text-esbelta-violet transition-colors" data-id="element-99">
            Inicio
          </a>
          <a href="#" className="text-sm font-medium text-gray-800 hover:text-esbelta-violet transition-colors" data-id="element-100">
            Catálogo
          </a>
          <a href="#" className="text-sm font-medium text-gray-800 hover:text-esbelta-violet transition-colors" data-id="element-101">
            Contacto
          </a>
        </nav>

        {/* Icons */}
        <div className="flex items-center gap-4 text-gray-800" data-id="element-102">
          <button aria-label="Search" className="hover:text-esbelta-violet transition-colors" data-id="element-103">
            <SearchIcon className="w-5 h-5" data-id="element-104" />
          </button>
          <button aria-label="Account" className="hover:text-esbelta-violet transition-colors hidden sm:block" data-id="element-105">
            <UserIcon className="w-5 h-5" data-id="element-106" />
          </button>
          <button aria-label="Cart" className="hover:text-esbelta-violet transition-colors relative" data-id="element-107">
            <ShoppingBagIcon className="w-5 h-5" data-id="element-108" />
            <span className="absolute -top-1 -right-1 bg-esbelta-violet text-white text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center" data-id="element-109">
              0
            </span>
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {isMenuOpen && <div className="md:hidden absolute top-16 left-0 w-full bg-white border-b border-gray-100 shadow-lg py-4 px-4 flex flex-col gap-4" data-id="element-110">
          <a href="#" className="text-base font-medium text-gray-800" data-id="element-111">
            Inicio
          </a>
          <a href="#" className="text-base font-medium text-gray-800" data-id="element-112">
            Catálogo
          </a>
          <a href="#" className="text-base font-medium text-gray-800" data-id="element-113">
            Contacto
          </a>
          <a href="#" className="text-base font-medium text-gray-800 flex items-center gap-2" data-id="element-114">
            <UserIcon className="w-5 h-5" data-id="element-115" /> Mi Cuenta
          </a>
        </div>}
    </header>;
}